import Title from "common/Typography/Title";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { AnalyticsPageName } from "@shared/types";
import {
  AFFILIATION_ARTICLE_ID,
  SMALL_TITLE_SCREEN,
} from "features/affiliation/common/constants";
import Flex from "common/Boxes/Flex";
import useMedia from "utils/hooks/useMedia";
import { ValueTitle } from "./styles";
import LastMonthChange from "features/affiliation/common/LastMonthChange";
import { LARGE_MOBILE, LARGE_TABLET, SMALL_MOBILE } from "common/constants";

interface StatisticItemProps {
  title: string;
  value: number | string;
  helperTooltip?: string;
  isBottomTitle?: boolean;
  lastMonthChange?: number | string;
}

const StatisticItem = ({
  title,
  value,
  helperTooltip,
  isBottomTitle,
  lastMonthChange,
}: StatisticItemProps) => {
  const isSmallTitle = useMedia(
    [`(max-width: ${SMALL_TITLE_SCREEN})`],
    [true],
    false
  );
  const hideLastMonthChange = useMedia(
    [
      `(max-width: ${SMALL_MOBILE})`,
      `(max-width: ${LARGE_MOBILE})`,
      `(max-width: ${LARGE_TABLET})`,
      `(min-width: ${LARGE_TABLET})`,
    ],
    [true, false, true, false],
    false
  );
  const longValue = value.toString().length > 6;

  return (
    <Flex $flexDirection="column" style={{ margin: "0 auto" }}>
      <Title
        level={5}
        type="secondary"
        style={{
          order: isBottomTitle ? 2 : 0,
          textAlign: "center",
          margin: isSmallTitle ? 4 : 0,
        }}
      >
        {title}
        {helperTooltip && (
          <HelperTooltip
            analyticsPageName={AnalyticsPageName.AFFILIATION}
            analyticsFieldName={title}
            description={helperTooltip}
            articleId={AFFILIATION_ARTICLE_ID}
          />
        )}
      </Title>
      <ValueTitle $longValue={longValue}>{value}</ValueTitle>
      {lastMonthChange !== undefined && !hideLastMonthChange && (
        <LastMonthChange lastMonthChange={lastMonthChange} />
      )}
    </Flex>
  );
};

export default StatisticItem;
